export const INFORMATION_REQUEST = {
  download: 'download',
  delete: 'delete',
} as const;

export type InformationRequestType = valueof<typeof INFORMATION_REQUEST>;
